<template>
    <div class="authorize">
        <div class="authorize-tip">
            <p>您的应用已经发布成功！请向充电运营商发起站点授权请求，运营</p>
            <p>商通过后，您的应用将可以正常调用对应授权充电桩的充电服务。</p>
        </div>
        <div class="btn-cont">
            <el-button type="primary" @click="linkToStation">申请站点授权</el-button>
        </div>
    </div>
</template>
<script>
import { Message } from 'element-ui';
import {http, apiJson} from "@/utils/http"
export default {
    data () {
        return {
            
        }
    },
    created () {
        this.$store.dispatch('changeDefaultActive','records')
    },
    updated () {
        console.log("sss")
    },
    methods: {
        linkToStation () {
            let {params} = this.$route
            this.$router.push(`/create-app/${params.id}/station`)
        }
    }
}
</script>
<style lang="scss" scoped>
    .authorize {
        width: 100%;
        height: 920px;
        border-left: 1px solid #e5e5e5;
        .authorize-tip {
            width: 500px;
            margin: 191px auto 72px;
            p {
                font-size: 16px;
                color: #333333;
                line-height: 28px;
                text-align: center;
            }
        }
        .btn-cont {
            width: 500px;
            margin: 0 auto;
            .el-button {
                display: block;
                margin: 0 auto;
                color: #ffffff;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/pages/CreateApp/before-station.vue